/**
 * Script para manejar el checkout con el idioma correcto
 * Intercepta el submit del formulario del carrito y redirige al checkout
 * con el mercado/idioma correcto basado en la URL actual
 */
(function() {
  'use strict';

  // Detectar el idioma actual basado en la URL
  function getCurrentLocale() {
    const pathname = window.location.pathname;
    if (pathname.startsWith('/en/') || pathname === '/en' || pathname.startsWith('/en?')) {
      return 'en';
    }
    return 'es'; // Por defecto español
  }

  // Cambiar el mercado usando la API de Shopify Markets
  async function setMarket(locale) {
    try {
      // Método 1: Intentar cambiar el mercado usando el formulario de localización de Shopify
      const localizationForm = document.querySelector('localization-form');
      if (localizationForm) {
        const form = localizationForm.querySelector('form');
        if (form) {
          const localeInput = form.querySelector('input[name="locale_code"]');
          if (localeInput) {
            localeInput.value = locale;
            // Enviar el formulario de forma asíncrona
            const formData = new FormData(form);
            const response = await fetch(form.action || '/localization', {
              method: 'POST',
              body: formData,
              redirect: 'manual'
            }).catch(() => null);
            
            if (response && response.ok) {
              return true;
            }
          }
        }
      }
      
      // Método 2: Usar la API de localización directamente
      try {
        const response = await fetch('/localization', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `locale_code=${locale}`,
          redirect: 'manual'
        });
        
        if (response && (response.ok || response.status === 302 || response.status === 303)) {
          return true;
        }
      } catch (e) {
        // Continuar con el siguiente método
      }
      
      // Método 3: Si estamos en inglés, intentar usar la URL del mercado directamente
      // En Shopify Markets, el mercado puede estar en la URL
      if (locale === 'en') {
        // Verificar si hay un mercado configurado en la URL
        const currentUrl = window.location.href;
        if (currentUrl.includes('/en/')) {
          // El mercado ya está en la URL, debería estar configurado
          return true;
        }
      }
      
      return false;
    } catch (error) {
      console.warn('No se pudo cambiar el mercado:', error);
      return false;
    }
  }

  // Interceptar el submit del formulario del carrito
  function interceptCartFormSubmit() {
    const cartForm = document.getElementById('cart');
    if (!cartForm) return;
    
    // Evitar agregar múltiples listeners
    if (cartForm.dataset.checkoutLocaleHandler === 'true') return;
    cartForm.dataset.checkoutLocaleHandler = 'true';

    cartForm.addEventListener('submit', async function(e) {
      const checkoutButton = e.submitter || cartForm.querySelector('button[name="checkout"]');
      
      // Solo interceptar si es el botón de checkout
      if (!checkoutButton || checkoutButton.name !== 'checkout') {
        return; // Permitir el submit normal para otros botones
      }

      e.preventDefault();
      e.stopPropagation();

      const currentLocale = getCurrentLocale();
      
      // Cambiar el mercado antes de redirigir al checkout
      if (currentLocale === 'en') {
        await setMarket('en');
        // Pequeña pausa para asegurar que el cambio se procese
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // Redirigir al checkout
      // Shopify redirigirá automáticamente al checkout con el mercado correcto
      window.location.href = '/checkout';
    });
  }

  // Interceptar clics en botones de checkout fuera del formulario
  function interceptCheckoutButtons() {
    // Botón de checkout en main-cart-footer
    const checkoutButton = document.getElementById('checkout');
    if (checkoutButton && !checkoutButton.dataset.checkoutLocaleHandler) {
      checkoutButton.dataset.checkoutLocaleHandler = 'true';
      checkoutButton.addEventListener('click', async function(e) {
        const form = document.getElementById('cart');
        if (!form) return;

        // Si el botón está dentro de un formulario, prevenir el submit normal
        if (checkoutButton.form === form || checkoutButton.getAttribute('form') === 'cart') {
          e.preventDefault();
          e.stopPropagation();

          const currentLocale = getCurrentLocale();
          
          if (currentLocale === 'en') {
            await setMarket('en');
            await new Promise(resolve => setTimeout(resolve, 100));
          }

          window.location.href = '/checkout';
        }
      });
    }

    // Botón de checkout en cart-drawer
    const cartDrawerCheckout = document.getElementById('CartDrawer-Checkout');
    if (cartDrawerCheckout && !cartDrawerCheckout.dataset.checkoutLocaleHandler) {
      cartDrawerCheckout.dataset.checkoutLocaleHandler = 'true';
      cartDrawerCheckout.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();

        const currentLocale = getCurrentLocale();
        
        if (currentLocale === 'en') {
          await setMarket('en');
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        window.location.href = '/checkout';
      });
    }

    // Botón de checkout en cart-notification
    const cartNotificationForm = document.getElementById('cart-notification-form');
    if (cartNotificationForm && !cartNotificationForm.dataset.checkoutLocaleHandler) {
      cartNotificationForm.dataset.checkoutLocaleHandler = 'true';
      cartNotificationForm.addEventListener('submit', async function(e) {
        const checkoutButton = e.submitter || cartNotificationForm.querySelector('button[name="checkout"]');
        if (!checkoutButton || checkoutButton.name !== 'checkout') {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        const currentLocale = getCurrentLocale();
        
        if (currentLocale === 'en') {
          await setMarket('en');
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        window.location.href = '/checkout';
      });
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      interceptCartFormSubmit();
      interceptCheckoutButtons();
    });
  } else {
    interceptCartFormSubmit();
    interceptCheckoutButtons();
  }

  // También interceptar después de actualizaciones dinámicas del carrito
  const observer = new MutationObserver(function(mutations) {
    interceptCartFormSubmit();
    interceptCheckoutButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

